import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../../images/logo.png';

class Header extends React.Component {
  render() {
    return (
      <span>
        <header className="section">
          <div className="logo center-align">
            <Link to="/">
              <img className="responsive-img" src={logo} alt="" />

            </Link>
          </div>
        </header>
        <div className="divider hdr-bdr" />
      </span>
    );
  }
}

export default withRouter(Header);
